import React from 'react';
import { useTranslation } from 'react-i18next';
import PrintDay from './PrintDay';

const PrintDayList = ({ days = [] }) => {
  const { t } = useTranslation();
  
  // Sort days by date
  const sortedDays = [...days].sort((a, b) => {
    if (!a.date || !b.date) return 0;
    return new Date(a.date) - new Date(b.date);
  });

  return (
    <div className="print-day-list">
      {sortedDays.length === 0 ? (
        <div className="text-center py-5">
          <p>{t('planDetail.print.noDaysAdded')}</p>
        </div>
      ) : (
        sortedDays.map((day, index) => (
          <div key={day.id || index} className="print-day-wrapper">
            {/* Each day is contained in its own div to help with page breaks */}
            <PrintDay 
              day={day} 
              dayNumber={index + 1}
            />
            {/* Add a page break hint after each day except the last one */}
            {index < sortedDays.length - 1 && (
              <div className="page-break-after"></div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default PrintDayList; 